<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DAuthorEditor',
  extends: compoment
}
</script>
